import { Flex, Text } from '@billy/design-system'

import * as Styled from './styles'

interface InvoiceSummaryTotalProps {
  label?: string
  text: string
}

export const InvoiceSummaryTotal = ({ label, text }: InvoiceSummaryTotalProps) => (
  <Styled.InvoiceSummaryTotal>
    <Flex justifyContent="space-between">
      <Text weight="bold">{label}</Text>
      <Text variant="h4" weight="bold">
        {text}
      </Text>
    </Flex>
  </Styled.InvoiceSummaryTotal>
)
